<ion-header>
  <ion-toolbar>
    <ion-title>Connecting to Spotify</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding callback-content">

  <!-- Loading state: token exchange in progress -->
  <div *ngIf="status === 'loading'" class="state-wrapper">
    <ion-spinner name="crescent" class="main-spinner"></ion-spinner>
    <p class="state-text">Exchanging authorization code&hellip;</p>
  </div>

  <!-- Success state: briefly visible before redirect -->
  <div *ngIf="status === 'success'" class="state-wrapper">
    <ion-icon name="checkmark-circle" class="icon-success"></ion-icon>
    <p class="state-text">Connected! Redirecting&hellip;</p>
  </div>

  <!-- Error state: show reason and retry -->
  <div *ngIf="status === 'error'" class="state-wrapper">
    <ion-icon name="close-circle" class="icon-error"></ion-icon>
    <p class="state-text error-text">{{ errorMessage }}</p>
    <ion-button expand="block" class="retry-btn" (click)="retryLogin()">
      Try Again
    </ion-button>
  </div>

</ion-content>
